const { getFirebaseData } = require('~/firebase/functions');
let defaultFirebase = require('~/firebase/index.js');
const firebase = defaultFirebase.default;

/**
 * Retorna os grupos de produtos
 */
export const getGroups = async () => {
    try {
        const response = {
            groups: {},
            products: {},
            ads: {}
        }

        const groups = await getFirebaseData('groups');
        const products = await getFirebaseData('products');
        const ads = await getFirebaseData('ads');

        if (groups.status === true) {
            response.groups = Object.assign({}, groups.data);
        }
        if (products.status === true) {
            response.products = Object.assign({}, products.data);
        }
        if (ads.status === true) {
            response.ads = Object.assign({}, ads.data);
        }

        for (let product in response.products) {
            if (response.products[product].status === 0) {
                delete response.products[product];
            } else if (!response.products[product].images) {
                response.products[product].images = [];
                response.products[product].images.push(process.env.REACT_APP_URL + '/images/no-product-image.png');
            }
            if (response.products[product]) {
                response.products[product].images.forEach((item, key) => {
                    if (typeof item !== 'object') {
                        response.products[product].images[key] = {
                            url: item,
                            colorKey: 'not-color-key'
                        }
                    }
                })
            }
        }

        //todo: converte para array
        if (response.groups) {
            let groups_keys = [];
            Object.keys(response.groups).forEach(group_key => {
                groups_keys.push(group_key);
            });
            response.groups = Object.entries(response.groups).map((e) => ({ [e[0]]: e[1] }));
            //todo: joga os valores que antes eram objetos, dentro do array criado anteriormente
            response.groups.forEach((element, key) => {
                let newObjects = {};
                for (let item in response.groups[key]) {
                    newObjects = response.groups[key][item];
                }
                newObjects._id = groups_keys[key];
                response.groups[key] = newObjects;
            });
        }
        if (response.ads) {
            response.ads = Object.entries(response.ads).map((e) => ({ [e[0]]: e[1] }));
            response.ads.forEach((element, key) => {
                let newObjects = {};
                for (let item in response.ads[key]) {
                    newObjects = response.ads[key][item];
                }
                response.ads[key] = newObjects;
            });

            response.ads.filter(item => item.status === 1);
        }
        await Promise.all(
            Object.keys(response.products).map(async key => {
                const newPrice = await getUserProductPrice(key);
                if (newPrice !== false) {
                    response.products[key].price = newPrice;
                    response.products[key].showPrice = true;
                }
                else {
                    response.products[key].showPrice = false;
                }
                return true;
            })
        );

        return {
            status: true,
            groups: response.groups || [],
            products: response.products || {},
            ads: response.ads || []
        }

    }
    catch (error) {
        return {
            status: false,
            message: error
        }
    }
}
/**
 * Retorna as categorias cadastradas
 */
export const getCategories = async () => {
    try {
        let response = {
            categories: {}
        }
        let categories = await getFirebaseData('categories');
        if (categories.status === true) response.categories = Object.assign({}, categories.data);
        if (response.categories) {
            //todo: converte para array
            response.categories = Object.entries(response.categories).map((e) => ({ [e[0]]: e[1] }));
            //todo: joga os valores que antes eram objetos, dentro do array criado anteriormente
            response.categories.forEach((element, key) => {
                let newObjects = {};
                for (let item in response.categories[key]) {
                    newObjects = response.categories[key][item];
                }
                newObjects._id = Object.keys(element)[0];
                response.categories[key] = newObjects;
            });
        }
        return {
            status: true,
            categories: response.categories || []
        }

    }
    catch (error) {
        return {
            status: false,
            message: error
        }
    }
}
/**
 * Retorna os atributos cadastrados
 */
export const getAttributes = async () => {
    try {
        let response = {
            attributes: {}
        }

        let attributes = await getFirebaseData('attributes');
        /**
         * Monta um array com o objeto atributo fora do objeto produto
         */
        if (attributes.status === true) {
            attributes = Object.assign({}, attributes.data);
            let attributes_keys = [];
            Object.keys(attributes).forEach(attributeKey => {
                attributes_keys.push({
                    _id: attributeKey
                });
                let indexOf = (attributes_keys.length - 1);
                for (let item in attributes[attributeKey]) {
                    attributes_keys[indexOf][item] = attributes[attributeKey][item]
                }

                //todo: trata os filhos do atributo
                let newChildren = [];
                let childrens = attributes_keys[indexOf].children;
                Object.keys(childrens).forEach(childrenKey => {
                    newChildren.push({
                        _id: childrenKey
                    });
                    for (let item in childrens[childrenKey]) {
                        newChildren[newChildren.length - 1][item] = childrens[childrenKey][item];
                    }
                });

                //todo: os filhos passam a serem de acordo com a tratativa feita anteriormente
                attributes_keys[indexOf].children = newChildren;
            });
            response.attributes = attributes_keys;
            return {
                status: true,
                attributes: response.attributes || []
            }
        } else {
            return {
                status: false,
                message: 'request_returned_empty'
            }
        }
    }
    catch (error) {
        return {
            status: false,
            message: error
        }
    }
}
/**
 * Retorna os produtos de uma categoria
 * @param {*} category_id 
 */
export const getProductsByCategory = async (category_id) => {
    if (!category_id) return { status: false, message: 'invalid_category' }
    try {
        let response = await getFirebaseData('categories/' + category_id);
        let categoryData = {};
        let products = [];
        let attributes = [];
        let ads = {}
        if (response.status === true) {
            categoryData = Object.assign({}, response.data);
            response.data.products.forEach(async (product_id) => {
                let productResponse = await getProductData(product_id);
                if (productResponse.status === true) {
                    products.push({
                        ...productResponse.product,
                        colors: productResponse.colors || []
                    });
                }
            });
            let responseAttributes = await getAttributes();
            if (responseAttributes.status === true) {
                attributes = responseAttributes.attributes;
            }
        }

        return {
            status: true,
            products: products || [],
            ads: ads || {},
            attributes: attributes || [],
            category: categoryData || {},
          };
    }
    catch (error) {
        return {
            status: false,
            message: error
        }
    }
}
export const getAttributeById = async (attribute_id) => {
    try {
        let attributes = await getFirebaseData('attributes/' + attribute_id);
        if (attributes.status === true) {
            return {
                status: true,
                data: attributes.data
            }
        } else {
            return {
                status: false,
                message: 'not_to_return',
                error: attributes
            }
        }
    }
    catch (error) {
        return {
            status: true,
            message: error
        }
    }
}
/**
 * Pega o valor de um produto na tabela do usuário
 * @param {*} product_id 
 * @returns number|boolean
 */
export const getUserProductPrice = async (productKey) => {
    try {
        if (!productKey) return false;
        const userId = localStorage.getItem('user_id');
        if (!userId) return false;

        const response = await getFirebaseData(`user-table/${userId}`);
        if (response.status === false) return false;

        const tablekey = response.data.tableKey;

        const prices = (await firebase.database().ref(`prices`).orderByChild('tableKey').equalTo(tablekey).once('value')).val();
        if (!prices) return false;
        let pricesList = [];
        Object.keys(prices).map(priceKey => {
            pricesList.push({
                ...prices[priceKey],
                priceKey
            });
        });

        const priceData = pricesList.find(item => item.productKey === productKey);
        if (!priceData) return false;

        return priceData.price;
    }
    catch (error) {
        return false;
    }
}
/**
 * Lista os tamanhos do produto
 * @param {*} tables 
 * @returns array
 */
const getProductDataWeights = async (tables) => {
    let weights = [];
    if (tables.weightsTableKey) weights = (await getFirebaseData(`weights-tables/${tables.weightsTableKey}/weights`)).data || [];

    return weights;
}
/**
 * Lista as cores do produto
 * @param {*} tables 
 * @returns array
 */
const getProductDataColors = async (tables) => {
    let colors = [];
    if (tables.colorsTableKey) colors = (await getFirebaseData(`table-colors/${tables.colorsTableKey}`)).data || [];

    return colors;
}
/**
 * Lista as categorias do produto
 * @param {*} product_id 
 * @returns array
 */
const getProductDataCategories = async (product_id) => {
    const response = await getCategories();
    if (response.status === false) return [];
    let categories = [];

    response.categories.map(item => {
        const hasCurrentProduct = item.products && item.products.includes(product_id);
        if (hasCurrentProduct) {
            categories.push(item);
            return true;
        } else {
            return false;
        }
    });

    return categories;
}
/**
 * Retorna os dados de um produto específico
 * @param {*} product_id 
 */
export const getProductData = async (product_id) => {
    if (!product_id) {
        return {
            status: false,
            message: 'invalid_product_id'
        }
    }
    try {
        let response = {
            product: {},
            weights: [],
            colors: []
        }


        const product = await getFirebaseData(`products/${product_id}`);
        if (!product.status === true) return { status: false, message: 'not_to_return' };
        response.product = product.data;
        response.product._id = product_id;

        response.product.categories = await getProductDataCategories(product_id);

        const price = await getUserProductPrice(product_id);
        response.product.price = price !== false ? price : response.product.price;
        if (price === false) {
            response.product.showPrice = false;
        }
        else {
            response.product.showPrice = true;
        }

        const tables = (await getFirebaseData(`product-tables/${product_id}`)).data;
        if (tables) {
            response.weights = await getProductDataWeights(tables, product_id);
            response.colors = await getProductDataColors(tables, product_id);
        }

        response.product.available = true;
        if ((response.weights.length === 0) && (response.colors.length === 0)) response.product.available = false;

        if (!response.product.images || !Array.isArray(response.product.images)) {
            response.product.images = [{
                url: process.env.PUBLIC_URL + '/images/no-product-image.png',
                colorKey: 'not-color-key'
            }];
        }
        response.product.images.forEach((item, key) => {
            if (typeof item !== 'object') {
                response.product.images[key] = {
                    url: item,
                    colorKey: 'not-color-key'
                }
            }
        })

        return {
            status: true,
            ...response
        };
    }
    catch (error) {
        return {
            status: false,
            message: error
        }
    }
}
/**
 * Retorna os produtos relacionados à um produto específico
 * @param {*} product_id 
 */
export const getSimilarProducts = async (category_id) => {
    if (!category_id) return { status: false, message: 'empty_categories' };
    try {
        let response = {
            products: []
        }
        let categories = await getFirebaseData('categories/' + category_id);
        if (categories.status === true) {
            await Promise.all(Object.values(categories.data.products).map(async key => {
                let product_data = await getProductData(key);
                if (product_data.status === true) response.products.push(product_data.product);
            }));
            return {
                status: true,
                products: response.products.sort(item => {
                    if (item.available === true) {
                        return -1
                    } else {
                        return 1;
                    }
                }),
            }
        } else {
            return {
                status: false,
                message: 'not_to_return',
                error: categories
            }
        }

    }
    catch (error) {
        return {
            status: false,
            message: error
        }
    }
}